import { Factory } from '../../../lib/api';
const getAreaTeams = (areaId) => Factory.get('api/v1/teams/list', { area_id: areaId });
export default getAreaTeams;
